import type { StoreApi } from "zustand";

import type { GenomeViewerStore } from "../../store/store.ts";
import type { WorkerMessage } from "../../types.ts";
import { refreshMain } from "../render-main.ts";

const MESSAGE_TYPES = {
  ALIGNMENT_IMAGE_BITMAP: "alignmentImageBitmap",
} as const;

// Worker Management
export function setupSyntenyWorkerMessageHandler(
  set: StoreApi<GenomeViewerStore>["setState"],
  get: StoreApi<GenomeViewerStore>["getState"],
) {
  // Separate handler for syntenic alignment worker
  const syntenyWorker = get().syntenyWorker;
  if (syntenyWorker) {
    syntenyWorker.onmessage = function (e) {
      if (e.data?.type === MESSAGE_TYPES.ALIGNMENT_IMAGE_BITMAP) {
        handleAlignmentImageBitmap(e.data, get, set);
      }
    };
  }
}

function handleAlignmentImageBitmap(
  data: WorkerMessage["AlignmentImageBitmap"],
  get: StoreApi<GenomeViewerStore>["getState"],
  set: StoreApi<GenomeViewerStore>["setState"],
) {
  const { imageBitmap, scrollX, scrollY, basePerPixel } = data;
  const currentBitmap = get().alignmentImageBitmap;

  if (currentBitmap) {
    currentBitmap.close();
  }

  set({
    alignmentImageBitmap: imageBitmap,
    alignmentImageBitmapScrollX: scrollX,
    alignmentImageBitmapScrollY: scrollY,
    alignmentImageBitmapBasePerPixel: basePerPixel,
  });

  refreshMain();
}
